import { useState } from "react";
import instance from "../../Interceptor/api_instance";
import { useAuth } from "../../Auth/AuthProvider";
import { useTranslation } from "react-i18next";
import { SpinnerOverlay } from "../../Components/LoadingAnimations/SpinnerOverlay";
import { useApiMutation } from "../../Hooks/useApiMutation";

export const Preferences = () => {
  const { t } = useTranslation();
  const { user, updateSettings } = useAuth();
  const [formData, setFormData] = useState({
    theme: user.theme,
    user_language: user.user_language,
  });

  const {
    mutate: patchSettings,
    isLoading,
    error,
  } = useApiMutation(async (payload, { signal }) => {
    const res = await instance.patch("api/update-settings", payload, {
      signal,
    });
    return res;
  });

  const saveChanges = async (e) => {
    e.preventDefault();
    try {
      const response = await patchSettings(formData, { cancelPrevious: true });
      if (response.status === 200) {
        updateSettings(response.data);
      }
    } catch (error) {
      console.error("Error updating settings:", error);
    }
  };

  const updateSetting = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  return (
    <div className="settings-cont">
      {isLoading && <SpinnerOverlay />}
      <h2 className="global-h2 black appearance-setting">
        {t("page-headers.appearance")}
      </h2>
      {error && <p className="error">{error}</p>}
      <form onSubmit={saveChanges}>
        <div className="personal-info-cont">
          <h4 className="global-h4 gray">
            {t("page-subheaders.interface-theme")}
          </h4>
          <div className="themes-cont">
            <label className="theme-option">
              <input
                type="radio"
                name="theme"
                value="System"
                className="theme-radio"
                onClick={updateSetting}
                checked={formData.theme === "System"}
              />
              <img src={"LoginScreenShot.png"} alt="" />
              {formData.theme === "System" && (
                <div className="theme-check-cont">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="49"
                    viewBox="0 0 50 49"
                    fill="none"
                  >
                    <g filter="url(#filter0_d_922_8156)">
                      <path
                        d="M25 4.8999C14.22 4.8999 5.39999 13.7199 5.39999 24.4999C5.39999 35.2799 14.22 44.0999 25 44.0999C35.78 44.0999 44.6 35.2799 44.6 24.4999C44.6 13.7199 35.78 4.8999 25 4.8999ZM21.325 34.5449C20.59 34.5449 19.855 34.2999 19.365 33.8099C19.365 33.8099 19.12 33.8099 19.12 33.5649C19.12 33.5649 19.12 33.5649 18.875 33.3199L12.995 27.4399C11.77 26.2149 11.77 24.2549 12.995 23.0299C14.22 21.8049 16.18 21.8049 17.405 23.0299L21.325 26.9499L32.595 15.4349C33.82 14.2099 35.78 14.2099 37.005 15.4349C38.23 16.6599 38.23 18.6199 37.005 19.8449L23.53 33.5649C23.04 34.2999 22.06 34.5449 21.325 34.5449Z"
                        fill="#CFBEFF"
                      />
                      <path
                        d="M37.005 19.8449L23.53 33.5649C23.04 34.2999 22.06 34.5449 21.325 34.5449C20.59 34.5449 19.855 34.2999 19.365 33.8099C19.365 33.8099 19.12 33.8099 19.12 33.5649C19.12 33.5649 19.12 33.5649 18.875 33.3199L12.995 27.4399C11.77 26.2149 11.77 24.2549 12.995 23.0299C14.22 21.8049 16.18 21.8049 17.405 23.0299L21.325 26.9499L32.595 15.4349C33.82 14.2099 35.78 14.2099 37.005 15.4349C38.23 16.6599 38.23 18.6199 37.005 19.8449Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <filter
                        id="filter0_d_922_8156"
                        x="-3.8"
                        y="-4.3"
                        width="57.6"
                        height="57.6"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                      >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                          in="SourceAlpha"
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                          result="hardAlpha"
                        />
                        <feOffset />
                        <feGaussianBlur stdDeviation="2.15" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                          type="matrix"
                          values="0 0 0 0 0.956863 0 0 0 0 0.956863 0 0 0 0 1 0 0 0 0.4 0"
                        />
                        <feBlend
                          mode="normal"
                          in2="BackgroundImageFix"
                          result="effect1_dropShadow_922_8156"
                        />
                        <feBlend
                          mode="normal"
                          in="SourceGraphic"
                          in2="effect1_dropShadow_922_8156"
                          result="shape"
                        />
                      </filter>
                    </defs>
                  </svg>
                </div>
              )}
              <h5 className="global-h5">{t("settings.themes.system")}</h5>
            </label>
            <label className="theme-option">
              <input
                type="radio"
                name="theme"
                value="Agramont"
                className="theme-radio"
                onClick={updateSetting}
                checked={formData.theme === "Agramont"}
              />
              <img src={"LoginScreenShot2.png"} alt="" />
              {formData.theme === "Agramont" && (
                <div className="theme-check-cont">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="49"
                    viewBox="0 0 50 49"
                    fill="none"
                  >
                    <g filter="url(#filter0_d_922_8156)">
                      <path
                        d="M25 4.8999C14.22 4.8999 5.39999 13.7199 5.39999 24.4999C5.39999 35.2799 14.22 44.0999 25 44.0999C35.78 44.0999 44.6 35.2799 44.6 24.4999C44.6 13.7199 35.78 4.8999 25 4.8999ZM21.325 34.5449C20.59 34.5449 19.855 34.2999 19.365 33.8099C19.365 33.8099 19.12 33.8099 19.12 33.5649C19.12 33.5649 19.12 33.5649 18.875 33.3199L12.995 27.4399C11.77 26.2149 11.77 24.2549 12.995 23.0299C14.22 21.8049 16.18 21.8049 17.405 23.0299L21.325 26.9499L32.595 15.4349C33.82 14.2099 35.78 14.2099 37.005 15.4349C38.23 16.6599 38.23 18.6199 37.005 19.8449L23.53 33.5649C23.04 34.2999 22.06 34.5449 21.325 34.5449Z"
                        fill="#CFBEFF"
                      />
                      <path
                        d="M37.005 19.8449L23.53 33.5649C23.04 34.2999 22.06 34.5449 21.325 34.5449C20.59 34.5449 19.855 34.2999 19.365 33.8099C19.365 33.8099 19.12 33.8099 19.12 33.5649C19.12 33.5649 19.12 33.5649 18.875 33.3199L12.995 27.4399C11.77 26.2149 11.77 24.2549 12.995 23.0299C14.22 21.8049 16.18 21.8049 17.405 23.0299L21.325 26.9499L32.595 15.4349C33.82 14.2099 35.78 14.2099 37.005 15.4349C38.23 16.6599 38.23 18.6199 37.005 19.8449Z"
                        fill="white"
                      />
                    </g>
                    <defs>
                      <filter
                        id="filter0_d_922_8156"
                        x="-3.8"
                        y="-4.3"
                        width="57.6"
                        height="57.6"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                      >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                          in="SourceAlpha"
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                          result="hardAlpha"
                        />
                        <feOffset />
                        <feGaussianBlur stdDeviation="2.15" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                          type="matrix"
                          values="0 0 0 0 0.956863 0 0 0 0 0.956863 0 0 0 0 1 0 0 0 0.4 0"
                        />
                        <feBlend
                          mode="normal"
                          in2="BackgroundImageFix"
                          result="effect1_dropShadow_922_8156"
                        />
                        <feBlend
                          mode="normal"
                          in="SourceGraphic"
                          in2="effect1_dropShadow_922_8156"
                          result="shape"
                        />
                      </filter>
                    </defs>
                  </svg>
                </div>
              )}
              <h5 className="global-h5">Agramont</h5>
            </label>
          </div>
        </div>

        <div className="personal-info-cont">
          <h4 className="global-h4 gray">{t("page-subheaders.language")}</h4>
          <div className="languages-options">
            <button
              className="change-pwd-btn"
              value="en-US"
              type="button"
              name="user_language"
              onClick={updateSetting}
              disabled={formData.user_language === "en-US"}
            >
              English
            </button>

            <button
              value="es-MX"
              className="change-pwd-btn"
              type="button"
              name="user_language"
              onClick={updateSetting}
              disabled={formData.user_language === "es-MX"}
            >
              Español
            </button>
          </div>
        </div>
        <div>
          <button className="change-pwd-btn" type="submit">
            {t("buttons.save")}
          </button>
        </div>
      </form>
    </div>
  );
};
